import { NgModule, APP_INITIALIZER, ModuleWithProviders } from '@angular/core';
import { ServerConfigurationService } from './services/server-configuration.service';
import { HttpModule } from '../http/http.module';
import { CONFIG_URL } from './constants/consts';


export function init_app(serverConfigurationService: ServerConfigurationService) {
  const initAppFunction = () => { return serverConfigurationService.load(); };
  return initAppFunction;
}


@NgModule({
  imports: [
    HttpModule
  ],
  declarations: [],
  providers: [
    ServerConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [ServerConfigurationService],
      multi: true
    }
  ],
  exports:[]
})
export class ServerConfigurationModule {

  static forRoot(configUrl : string): ModuleWithProviders<ServerConfigurationModule> {
    return {
      ngModule: ServerConfigurationModule,
      providers:[
        {
          provide:CONFIG_URL,
          useValue:configUrl
        }
      ]
    }
  }
 }
